export const MedicalCustomFetch = (item) => {
    return new Promise((resolve, reject) => {
        resolve(item)
    })
}